<template>
  <div id="">
   <!-- <img src="./assets/logo.png"> -->
    <router-view/>
  </div>
</template>

<script>
// export default {
//   name: 'App'
// }
 export default {
    data() {
      return {

      };
    }
		
  };
</script>

<style>

</style>



// WEBPACK FOOTER //
// src/App.vue